<template>
    <div class="form_flex_wrap loading_top_wrap">
        <div v-if="isLoading" class="loading_bg round_none transparent" style="z-index: 999;">
            <div class="loading_wrap">
                <div class="loading_obj">
                    <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                    </svg>
                </div>
            </div>
        </div>
        <div class="form_flex_title">
            <span class="title">{{ $t('reservation_settings.section_appointment_operating_hours.title') }}</span>
            <span class="info mgl_auto">{{ $t('reservation_settings.section_appointment_operating_hours.sub_title') }}</span>
        </div>
        <div class="form_flex_cont">
            <ul class="form_list">
                <li class="title">{{ $t('reservation_settings.section_appointment_operating_hours.label_time_setting') }}</li>
                <li class="cont">
                    <label class="check_wrap" v-for="(time, index) in possibleTimes" :key="index">
                        <input type="checkbox" v-model="time.isSelected">
                        <span class="checkmark"></span>
                        {{ getDayOfWeek(time.index) }}
                    </label>

                    <small class="red_txt w_full mgt_10" v-if="isNotSelectedError">진료 가능 요일은 최소 1개 이상 선택해 주세요.</small>

                    <div class="cont_group">
                        <div class="mgt_10" v-for="(time, index) in possibleTimes" :key="index">
                            <div v-if="time.isSelected">
                                <span class="mgr_10" style="display: inline-block; width: 40px;">{{ getDayOfWeek(time.index) }}</span>
                                <TimePicker v-model="time.startedAt"/>
                                ~
                                <TimePicker v-model="time.endedAt"/>

                                <a class="btn lgray_txt btn_s mgl_10" v-if="isShowAllCopyButton(index)" @click="copyAllDaysOfWeek(index)">
                                    <v-icon>mdi-content-copy</v-icon>
                                    <small>{{ $t('reservation_settings.section_appointment_operating_hours.label_apply_to_all_days') }}</small>
                                </a>
                            </div>
                        </div>
                    </div>

                    <small class="red_txt w_full mgt_10" v-if="isTimeSettingError">종료시간은 시작시간보다 이전으로 설정할 수 없습니다.</small>
                </li>
            </ul>
        </div>
        <div class="btn_wrap">
            <div class="editor_info">{{ modifiedAt }} / {{ modifier }}</div>
            <button class="btn btn_l btn_blue mgl_auto" @click="reqeustUpdateReservationSetting">
                {{ $t('common.save') }}
            </button>
        </div>
    </div>
</template>

<script>
const moment = require('@/util/MPMoment')
import TimePicker from '../../../../../ShareComponents/Common/TimePickerHM.vue'
import { useQueryClient } from '@tanstack/vue-query'
import { v2ReservationSettingFindOneQueryOptions } from '@/composables/queries/v2reservationsetting/use-v2-reservationsetting-find-one-query'
import { useV2ReservationSettingUpdateMutation } from '@/composables/queries/v2reservationsetting/use-v2-reservationsetting-update-mutation'

export default {
    setup() {
        const queryClient = useQueryClient()
        const { mutateAsync: updateReservationSetting } = useV2ReservationSettingUpdateMutation()
        return { queryClient, updateReservationSetting }
    },
    components: { TimePicker },
    props: {

    },
    data() {
        return {
            isLoading: false,
            isSaving: false,

            result: undefined,
            modifiedID: undefined,
            isNotSelectedError: false,
            isTimeSettingError: false,
        }
    },
    watch: {
        selectedTimes: {
            handler: function(newValue) {
                if (newValue?.length > 0)  {
                    this.isNotSelectedError = false
                }
            }
        }
    },
    computed: {
        possibleTimes: function() {
            return this.result?.possibleTimes ?? []
        },
        modifiedAt: function() {
            if (this.result?.possibleTimesModifiedAt == undefined) {
                return '-'
            } else {
                return moment(this.result?.possibleTimesModifiedAt).format(this.$t('common.date_format_YYYY_MM_DD_HH_mm'))
            }
        },
        modifier: function() {
            if (this.result?.possibleTimesModifierID == undefined) {
                return '-'
            } else {
                if (this.result.possibleTimesModifierID.type >= 3000) {
                    return this.$t('reservation_settings.section_appointment_operating_hours.label_modified_afterdoc')
                } else {
                    return `${this.result.possibleTimesModifierID.realName} ${this.$t('reservation_settings.section_appointment_operating_hours.label_modified')}`
                }
            }
        },
        selectedTimes: function() {
            return this.possibleTimes.filter(t => t.isSelected)
        }
    },
    mounted() {
        this.reqeustFetchReservationSetting()
    },
    methods: {
        getDayOfWeek(index) {
            if (index == 0) { return this.$t('common.sun') }
            if (index == 1) { return this.$t('common.mon') }
            if (index == 2) { return this.$t('common.tue') }
            if (index == 3) { return this.$t('common.wed') }
            if (index == 4) { return this.$t('common.thu') }
            if (index == 5) { return this.$t('common.fri') }
            if (index == 6) { return this.$t('common.sat') }
            return '-'
        },
        // 모든요일 적용 버튼 노출여부
        isShowAllCopyButton: function(index) {
            return this.possibleTimes.findIndex(t => t.isSelected) == index
        },
        // 모든요일 적용
        copyAllDaysOfWeek(index) {
            let target = this.possibleTimes[index]
            this.possibleTimes.forEach(time => {
                time.startedAt = target.startedAt
                time.endedAt = target.endedAt
            })
        },
        // 변경데이터 필수조건 체크
        checkParameter() {
            if (this.selectedTimes.length == 0) {
                this.isNotSelectedError = true
                return false
            }

            for (let i = 0; i < this.possibleTimes.length; i ++) {
                let current = this.possibleTimes[i]
                let startTime = moment(current.startedAt)
                let endTime = moment(current.endedAt)
                let s = moment().startOf('days').add(startTime.hours(), 'hours').add(startTime.minutes(), 'minutes')
                let e = moment().startOf('days').add(endTime.hours(), 'hours').add(endTime.minutes(), 'minutes')

                if (s.isSame(e) || s.isAfter(e)) {
                    this.isTimeSettingError = true
                    return false
                }
                this.isTimeSettingError = false
            }
            return true
        },
        // 예약설정 조회
        async reqeustFetchReservationSetting() {
            try {
                this.isLoading = true
                let param = {
                    hospitalID: this.hospital.selectedHospital._id
                }
                // 봉투 에러(code != 0)는 ApiError로 throw — 아래 catch에서 로그 (기존 동작 동일)
                const fetched = await this.queryClient.fetchQuery(v2ReservationSettingFindOneQueryOptions(param))
                // 캐시 공유 객체를 직접 변형하지 않도록 복사 후 시간 정규화
                const setting = {
                    ...fetched,
                    possibleTimes: fetched.possibleTimes.map(t => ({
                        ...t,
                        startedAt: moment(t.startedAt).set({ year: 2000, month: 0, date: 1 }).toString(),
                        endedAt: moment(t.endedAt).set({ year: 2000, month: 0, date: 1 }).toString()
                    }))
                }
                this.result = setting
            } catch (err) {
                console.log('reservation setting find error from operating hours component ', err)
            } finally {
                this.isLoading = false
            }
        },
        /*
         * 저장할 때 쓰는 분 숫자 — 자정으로부터 몇 분인가.
         *
         * 서버는 startMinutes/endMinutes 가 오면 그것으로 시간을 되돌리고 startedAt/endedAt 은
         * 버린다(toStoredReservationOperatingTimes). 화면이 바꾸는 것은 TimePicker 가 물린
         * startedAt/endedAt 뿐이라, 조회할 때 함께 받은 분 숫자를 그대로 돌려보내면 방금 고른
         * 시간이 옛 시간으로 되돌아간다. 응답이 성공이라 화면에는 티도 나지 않는다.
         *
         * 그래서 보낼 때 지금 값으로 다시 계산한다. moment 래퍼가 병원 타임존을 적용하므로
         * 여기서 읽는 시/분은 사용자가 화면에서 고른 그 시각이다.
         * 값이 성하지 않으면 비워 두고, 서버가 startedAt/endedAt 을 쓰게 둔다.
         */
        minutesOfDay(value) {
            let time = moment(value)
            if (!time.isValid()) { return undefined }
            return time.hours() * 60 + time.minutes()
        },
        // 예약설정 변경
        async reqeustUpdateReservationSetting() {
            try {
                if (this.isSaving) { return }

                this.isLoading = true
                this.isSaving = true

                if (!this.checkParameter()) { return }

                let data = {
                    _id: this.result._id,
                    hospitalID: this.hospital.selectedHospital._id,
                    possibleTimes: this.possibleTimes.map(time => ({
                        ...time,
                        startMinutes: this.minutesOfDay(time.startedAt),
                        endMinutes: this.minutesOfDay(time.endedAt)
                    }))
                }

                // 봉투 에러(code != 0)는 ApiError로 throw — 아래 catch에서 로그 (기존 동작 동일)
                this.result = await this.updateReservationSetting(data)
                this.setToast({
                    isShow: true,
                    text: this.$t('common.label_save_success')
                })
                this.isNotSelectedError = false
                this.isTimeSettingError = false
            } catch (err) {
                console.log('reservation setting update error from operating hours component ', err)
            } finally {
                this.isLoading = false
                this.isSaving = false
            }
        }
    }
}
</script>